var _style, _polygon, _path, _path2, _path3, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZktecoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "layer",
    x: "0px",
    y: "0px",
    viewBox: "-134 0 600 610",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0 {\n            fill: #494C50;\n        }\n\n        .st1 {\n            fill: #8AC142;\n        }\n    ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "170.4,206.7 96.9,260.9 133.1,345 93.7,345.1 69.1,281.7 40.1,304.5 31,345 -131.4,345.1 -126.9,319.3 -32.4,231.3 -102.1,231.3 -97.5,206.7 15.1,206.6 10.3,229.6 -88.9,320.5 5.7,320.4 31.6,206.6 64.1,206.7 49.7,266.3 125.3,206.6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 312.9 342.3 H 248 l 9.8 -43.5 h 46.4 l -3.9 17.4 h -27.8 l -2 8.7 l 46.3 0 L 312.9 342.3 z M 324.7 290.1 h -64.9 l 3.9 -17.4 h 64.9 L 324.7 290.1 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 388.2 324.9 c -0.9 4 -1.8 6.7 -2.6 8.4 c -1.4 2.9 -3.5 5 -6.3 6.5 c -3.3 1.7 -7.9 2.6 -13.7 2.6 l -27.8 0 c -6 0 -10.2 -0.9 -12.8 -2.8 c -2.1 -1.5 -3.1 -3.8 -3.1 -6.9 c 0 -1.1 0.1 -2.4 0.4 -3.7 c 0.1 -0.6 0.4 -1.9 0.9 -4 l 5.9 -26.1 h 18.6 l -5.9 26.1 h 27.8 l 2 -8.7 h 18.5 L 388.2 324.9 z M 394.1 298.8 h -18.5 l 2 -8.7 h -46.3 c 0.9 -3.9 1.7 -6.7 2.6 -8.3 c 1.4 -2.9 3.5 -5.1 6.2 -6.5 c 3.3 -1.7 7.9 -2.6 13.7 -2.6 h 27.8 c 6 0 10.2 0.9 12.7 2.8 c 2.1 1.6 3.1 3.9 3.1 6.9 c 0 1.1 -0.1 2.4 -0.4 3.8 c -0.1 0.5 -0.4 1.9 -0.8 3.9 L 394.1 298.8 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 459.6 324.9 c -0.9 3.9 -1.8 6.7 -2.6 8.4 c -1.4 2.9 -3.5 5 -6.3 6.5 c -3.3 1.7 -7.9 2.6 -13.6 2.6 h -27.8 c -6 0 -10.2 -0.9 -12.8 -2.8 c -2 -1.5 -3.1 -3.8 -3.1 -6.9 c 0 -1.1 0.1 -2.4 0.4 -3.7 c 0.1 -0.6 0.4 -1.9 0.9 -4 l 5.9 -26.1 h 18.5 l -5.9 26.1 H 441 l 7.9 -34.8 h -46.4 c 0.9 -3.9 1.7 -6.7 2.6 -8.3 c 1.4 -2.9 3.5 -5.1 6.3 -6.5 c 3.3 -1.7 7.9 -2.6 13.7 -2.6 h 27.8 c 6 0 10.2 0.9 12.7 2.8 c 2 1.6 3.1 3.9 3.1 6.9 c 0 1.1 -0.1 2.4 -0.4 3.8 c -0.1 0.5 -0.4 1.9 -0.9 3.9 L 459.6 324.9 z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170.3,206.7 291.2,206.6 283.3,231.6 238.5,231.6 204.5,344.9 174,345 206.7,231.4 136.6,231.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZktecoIcon);
export default __webpack_public_path__ + "static/media/zkteco-icon.5834501ba2bf8d485943e4543dad1485.svg";
export { ForwardRef as ReactComponent };